import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class InstitutioninforelationApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'institutioninforelation'
    }

    /**
     * 删除关系表数据
     * @param data
     */
    public deleteByparams(data) {
        return this.send(data, "deleteByparams", Methods.POST)
    }

    /**
     * 获取已配置的关系
     * @param data
     */
    public getListByParams(data) {
        return this.send(data, "getListByParams", Methods.GET)
    }

    /**
     * 修改hasChild状态
     * @param data
     */
    public updateChild(data) {
        return this.send(data, "updateChild", Methods.POST)
    }

    public deleteByIIdAndPid(iid,pid, branchId){
        return this.send({},"deleteByIIdAndPid?iid="+iid+"&pid="+pid+"&branchId="+branchId,Methods.POST)
    }

    /**
     * 修改isMain状态
     * @param data
     */
    public updateById(data) {
        return this.send(data, "updateById", Methods.POST)
    }

    /**
     * 查询分部负责人和驻地办监理
     * @param data
     */
    public getfbLeader(data) {
        return this.send(data, "getfbLeader", Methods.GET)
    }


}